import { gql } from '@apollo/client';

const VALIDATE_SCHEDULE_CYCLE_DAY = gql`
  query ValidateScheduleCycleDay(
    $scheduleId: String!
    $proposedCycleDay: Int!
  ) {
    validateScheduleCycleDay(
      scheduleId: $scheduleId
      proposedCycleDay: $proposedCycleDay
    ) {
      isValid
      validScheduleDays
    }
  }
`;

export { VALIDATE_SCHEDULE_CYCLE_DAY };
